import { ACCESS } from "@dictybase/auth-mui5"
import { NotFoundErrorAuth } from "@dictybase/ui-common"

// eslint-disable-next-line unicorn/prefer-export-from, import/no-default-export
export default NotFoundErrorAuth
export const access = ACCESS.private
export const roles = ["content-admin"]
